module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ainsley-abbitt-9b68c9c216e1f20e2ceae0654a70c40e.jpg";